<template>
  <div class="purchase-dialog-base">

    <div class="birthday-input-panel" v-if="pageNum === 1">
      <h4>相性を占いたい相手の情報を入力してください</h4>
      <div class="additional-info">

        <form-target-birthday
          name="target_birthday"
          type="tel"
          :value="targetBirthday"
          :placeholder-year="'2000'"
          :placeholder-month="'01'"
          :placeholder-day="'01'"
          db-value
          @change="onTargetDateChange"
          :validation="{ rules: {
            required: true,
            regex: birthVaridRegex,
            birthRange: true,
            max: 8,
            min: 8,
            } }"
        ></form-target-birthday>
        <input
          type="text"
          name="target_nickname"
          placeholder="ニックネーム"
          v-model="nicknameValue"
          @change="onNicknameChange"
          @keyup="onNicknameChange"
        />
        <div class="next-btn main-button" @click="onNextClick" :class="{disable: isNextDisable}">次へ</div>
      </div>
    </div>

    <div class="purchase-panel" v-if="pageNum === 2">
      <div class="item-info">
        <div class="image"><img :src="itemData.imageUrl" /></div>
        <!--<h4>{{ itemData.title }}</h4>-->
        <article-card-header
          :article-title="itemData.title"
          :target-id="textItemId"
        />
        <p>{{ itemData.summary }}</p>
      </div>
      <div class="type-select">
        <h4>商品タイプを選択してください</h4>
        <ul>
          <li class="radio-item">
            <input type="radio" name="itemType" value="t" id="pur-radio-t" v-model="radioStatus" />
            <label for="pur-radio-t"><span class="title"><img src="/static/img/yearluck/y2020/icon/text.svg" />テキスト</span><span class="price">{{ textPrice }}<span class="currency-unit">円（税込）</span></span></label>
          </li>
          <li>
            <input type="radio" name="itemType" value="ta" id="pur-radio-ta" v-model="radioStatus" :disabled="dontHaveAudio" />
            <label for="pur-radio-ta"><span class="title"><img src="/static/img/yearluck/y2020/icon/textonsei.svg" />テキスト ＆ 音声</span><span class="price">{{ textAudioPrice }}<span class="currency-unit">円（税込）</span></span></label>
          </li>
        </ul>
        <div class="purchase-submit-base"><span class="purchase-submit-btn main-button" :class="{disable: isSubmitDisable}" @click="onSubmitClick">購入へ進む</span></div>
      </div>
    </div>

    <div class="setmenu-info">
      <h4><img src="/static/img/yearluck/y2020/titlelabel/setmenu.svg"></h4>
      <p>お好みのセットで2020年の運勢をお得にゲット♪</p>
      <div class="purchase-submit-base"><span class="purchase-submit-btn main-button reverse" @click="onToSetmenuClick">お得なセットメニューはこちら</span></div>
    </div>
  </div>
</template>

<script>
import FormTargetBirthday from "./FormTargetBirthday";
import articleCardHeader from './articleCardHeader'

export default {
  name: "purchaseDialog",
  data() {
    return {
      radioStatus: 't',
      pageNum: 0,
      birthVaridRegex: /[12][0-9]{3}([1][0-2]|[0][1-9])(0[1-9]|[12][0-9]|3[01])/,
      now: new Date(),
      birthDefault: {
        year: '2000',
        month: '01',
        day: '01'
      },
      tgtBirthCheck: false,
      tgtNicknameCheck: false,
      isSubmitDisable: false,
      isNextDisable: false,
      nicknameValue: '',
      birthdayValue: '',
      isBirthFirstCheck: true
    }
  },
  components: { FormTargetBirthday, articleCardHeader },
  props: {
    targetIdx: {
      type: Number,
      default() {
        return -1
      }
    },
    itemData: {
      type: Object,
      default() {
        return {}
      }
    },
    textPrice: {
      type: Number,
      default() {
        return 0
      }
    },
    textAudioPrice: {
      type: Number,
      default() {
        return 0
      }
    },
    textItemId: {
      type: Number,
      default() {
        return -1
      }
    },
    hasSetMenuRecommend: {
      type: Boolean,
      default() {
        return false
      }
    },
    targetNicknameReceive: {
      type: String,
      default() {
        return ''
      }
    },
    targetBirthdayReceive: {
      type: String,
      default() {
        return ''
      }
    },
    isSetPurchase: {
      type: Boolean,
      default() {
        return false
      }
    },
    hasAffinity: {
      type: Boolean,
      default() {
        return false
      }
    },
    backUrl: {
      type: String,
      default() {
        return ''
      }
    },
    isSummary: {
      type: Boolean,
      default() {
        return false
      }
    }
  },
  watch: {
    radioStatus(val){},
  },
  mounted() {
    //ページ表示を確定する
    if(this.hasAffinity) {
      this.pageNum = 1
      this.nicknameValue = this.targetNicknameReceive
    } else {
      this.pageNum = 2
    }
    if(this.birthVaridRegex.test(this.targetBirthdayReceive)) {}
    setTimeout(() => this.checkCanSubmit(),100)
  },
  computed: {
    targetBirthday() {
      return this.targetBirthdayReceive
    },
    sepBirth() {
      const rtn = {}
      if(this.targetBirthday.length > 0 && this.birthDefault) {
        const y = parseInt(this.targetBirthday.substr(0,4))
        const m = parseInt(this.targetBirthday.substr(4,2))
        const d = parseInt(this.targetBirthday.substr(6,2))
        const tdate = new Date(y, (m - 1), d)
        const fdate = new Date(1940,0,1)
        const ndate = new Date(this.now.getFullYear(), this.now.getMonth(), this.now.getDate())
        if( fdate.getTime() < tdate.getTime() && tdate.getTime() <= ndate.getTime() ) {
          return {
            year: y,
            month: m,
            day: d
          }
        } else {
          return this.birthDefault
        }
      } else {
        return this.birthDefault
      }
    },
    submitEnable: {
      get() {
        if(this.itemData.section === 'affinity') {
          return this.submitEnableStat
        } else {
          return true
        }
      },
      set(stat) {
        this.submitEnableStat = !!stat
      }
    },
    dontHaveAudio() {
      return this.itemData.textItemId !== 273
             && this.itemData.textAudioItemId !== 274
             && this.itemData.textItemId !== 275
             && this.itemData.textAudioItemId !== 276
             && this.itemData.textItemId !== 277
             && this.itemData.textAudioItemId !== 278
             && this.itemData.textItemId !== 279
             && this.itemData.textAudioItemId !== 280
             && this.itemData.textItemId !== 285
             && this.itemData.textAudioItemId !== 286
    }
  },
  methods: {
    onTargetDateChange(birth, err) {
      this.tgtBirthCheck = !err
      this.birthdayValue = birth
      this.isBirthFirstCheck = false
      this.checkCanSubmit()
    },
    onSubmitClick(){
      if(this.isBirthFirstCheck){
        this.birthdayValue = this.targetBirthday
      }
      const addtionalInfo = {
        hasAffinity: this.hasAffinity,
        tgtNickname: this.nicknameValue,
        tgtBirthday: this.birthdayValue
      }

      if(!this.hasAffinity) {
        this.$emit('submit', this.radioStatus, this.targetIdx, this.isSetPurchase)
      }else {
        this.$emit('submit', this.radioStatus, this.targetIdx, this.isSetPurchase, addtionalInfo)
      }
    },
    onNextClick() {
      this.pageNum = 2
    },
    onNicknameChange() {
      const nn = this.$el.querySelector('input[name=target_nickname]')
      this.checkCanSubmit()
    },
    checkCanSubmit() {
      if(this.$el != null && typeof this.$el.querySelector !== undefined && this.hasAffinity) {
        const nn = this.$el.querySelector('input[name=target_nickname]')
        this.tgtNicknameCheck = /^.{1,8}$/.test(nn.value)

        if( ( this.isBirthFirstCheck && this.tgtNicknameCheck )
          || ( this.tgtBirthCheck && this.tgtNicknameCheck ) ) {

          this.isNextDisable = false
        } else {
          this.isNextDisable = true
        }
      }
    },
    onToSetmenuClick() {
      if(this.isSummary) {
        this.$emit('closeAndGoSet')
      } else {
        location.href = `${this.backUrl}#setmenu`
      }
    }
  }
}</script>

<style scoped lang="scss">
@import '../../../../../../sass/variables/index';

.purchase-dialog-base {
  color: $gray-20;
  .main-button {
    display: block;
    width: 100%;
    border: 2px solid $brown-10;
    line-height: 1;
    color: $brown-10;
    padding: 10px 12px 10px;
    font-size: 12px;
    font-weight: bold;
    text-align: center;
    transition: background-color 250ms ease-out 0s;
    position: relative;
    cursor: pointer;
    user-select: none;
    @include mq() {
      padding: 12px 12px 11px;
      font-size: 14px;
    }
    &::after {
      content: '';
      width: 10px;
      height: 18px;
      position: absolute;
      top: 0;
      bottom: 0;
      right: 16px;
      margin: auto;
      background: url('/static/img/yearluck/y2020/next.svg') no-repeat center center;
      background-size: auto 18px;
    }
    &.disable {
      border: 2px solid $gray-3;
      color: $gray-3;
      pointer-events: none;
      &:hover {
        background-color: white;
      }
    }
    &:hover {
      background-color: lighten($brown-10, 55%);
    }
    &.reverse {
      background: $brown-10;
      color: white;
      &::after {
        background: url('/static/img/yearluck/y2020/next_white.svg') no-repeat center center;
        background-size: auto 18px;
      }
    }
  }
  .type-select {
    /*
    input[type="radio"]{
      display: none;
    }
    label {
      &::before {
        content: '';
        display: inline-block;
        width: 20px;
        height: 20px;
        border: 1px solid red;
        border-radius: 10px;
      }
    }
    input[type="radio"]:checked + label {
      &::before {
        border: 1px solid blue;
      }
    }
    input[type="radio"]:disabled + label {
      color: $gray-7;
      &::before {
        border: 1px solid $gray-7;
      }
    }
     */
    .purchase-submit-base {
      width: 100%;
      .purchase-submit-btn {

      }
    }
  }
  .birthday-input-panel {
    padding-top: 30px;
    h4 {
      margin: 0;
      width: 100%;
      background: $brown-10;
      color: white;
      font-weight: bold;
      font-size: 12px;
      text-align: center;
      line-height: 1;
      padding: 8px 0;
      margin-bottom: 20px;
    }
    .additional-info {
      width: 100%;
      padding: 0 25px 32px;
      .formGroup {
        margin-bottom: 10px;
      }
      /deep/ .calenderForm {
        width: 100%;
        justify-content: center;
        input {
          flex-basis: 50px;
        }
      }
      input[name='target_nickname'] {
        width: 100%;
        border: 1px solid rgba(0, 0, 0, 0.15);
        text-align: center;
        font-size: 18px;
        padding: 12px;
        margin-bottom: 10px;
      }

    }
    .next-btn {
      &.disable {
        border: 2px solid $brown-10;
        color: $brown-10;
        opacity: 0.3;
      }

    }
  }

  .purchase-panel {
    width: 100%;
    .item-info {
      padding: 34px 16px 12px 130px;
      position: relative;
      @include mq('w320') {
        padding: 34px 25px 25px 140px;
      }
      .image {
        width: 100px;
        height: 100px;
        overflow: hidden;
        border-radius: 5px;
        position: absolute;
        top: 34px;
        left: 16px;
        @include mq(){
          left: 25px;
        }
        img {
          object-fit: cover;
          width: 100%;
          height: 100%;
          display: block;
        }
      }
      p {
        font-size: 11px;
        line-height: 17px;
      }
    }
    .type-select {
      h4 {
        margin: 0;
        width: 100%;
        background: $brown-10;
        color: white;
        font-weight: bold;
        font-size: 12px;
        text-align: center;
        line-height: 1;
        padding: 8px 0;
      }
      & > ul {
        $btnW: 20px;
        width: 100%;
        padding: 0;
        margin: 0;
        & > li {
          width: 100%;
          label {
            width: 100%;
            position: relative;
            padding: 6px 8px 6px ( $btnW + 16px );
            @include mq('w320') {
              padding: 12px 16px 12px ( $btnW + 16px + 8px );
            }
            border-bottom: 1px solid $gray-18;
            cursor: pointer;
            display: flex;
            justify-content: space-between;
            align-items: center;
            &::before,
            &::after {
              content: '';
              width: $btnW;
              height: $btnW;
              position: absolute;
              top: 0;
              bottom: 0;
              margin: auto;
              box-sizing: border-box;
              border-radius: $btnW / 2;
            }
            &::before {
              border: 1px solid $gray-14;
              width: $btnW;
              height: $btnW;
              left: 16px;
            }
            &::after {
              background: $gray-14;
              width: $btnW - 8px;
              height: $btnW - 8px;
              left: 20px;
              transition: all 200ms ease-out 0s;
              opacity: 0;
              transform: scale(0.5);
            }
            .title {
              vertical-align: middle;
              font-size: 11px;
              img {
                height: 16px;
                margin-right: 6px;
                vertical-align: middle;
                display: inline-block;
                margin-left: 6px;
                margin-bottom: 2px;              }
            }
            .price {
              font-size: 18px;
              @include mq('w320'){
                font-size: 24px;
              }
              font-weight: bold;
              .currency-unit {
                font-size: 11px;
              }
            }
          }
          input[type='radio'] {
            display: none;
            &:checked + label {
              &::after {
                opacity: 1;
                transform: scale(1);
              }
            }
            &:disabled + label {
              * {
                opacity: 0.3;
              }
              &::before {
                opacity: 0.3;
                transform: scale(1);
              }
            }
          }
        }
      }
      .purchase-submit-base {
        width: 100%;
        padding: 20px 25px;

      }
    }
  }
  .setmenu-info {
    width: 100%;
    background: url('/static/img/yearluck/y2020/maintitle_bg.png') repeat center center;
    background-size: 250px;
    text-align: center;
    font-size: 12px;
    padding-top: 16px;
    @include mq() {
      padding-top: 24px;
    }
    h4 {
      margin: 0;
      img {
        width: 90%;
        @include mq(){
          width: auto;
        }
      }

    }
    p {
      font-weight: bold;
      margin-bottom: 0;
    }
    .purchase-submit-base {
      width: 100%;
      padding: 16px 25px;
      @include mq('w320'){
        padding: 20px 25px;
      }
    }

  }
}
</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/YearLuck/y2020/partials/purchaseDialog.vue